export default "__VITE_ASSET__Cb9yhY8K__"